import { connect } from 'react-redux';

import Candidate from './component';

import {
  createFlaggedLink,
  createFlaggedTopic,
  fetchAllTopicsForRace,
  fetchCandidate,
  fetchRace,
  setRaceTopicMeaning,
  setSelectedCandidate,
} from '../../state/actions';

const mapStateToProps = (state) => {
  const {
    app: {
      nationalTopics,
    },
    candidates: {
      candidates,
      selectedCandidate,
    },
    races: {
      races: rawRaces,
      selectedRace,
    },
    flaggedLinks,
    flaggedTopics: {
      flaggedTopicsForRace,
    },
  } = state;

  const races = Object.values(rawRaces);

  return {
    candidates,
    flaggedLinks,
    nationalTopics,
    races,
    selectedCandidate,
    selectedRace,
    flaggedTopicsForRace,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createFlaggedLink: (link, onSuccess, onFailure) => {
      dispatch(createFlaggedLink({ link }, onSuccess, onFailure));
    },
    fetchCandidate: (candidateId) => {
      dispatch(fetchCandidate(candidateId));
    },
    fetchRace: (raceId) => {
      dispatch(fetchRace(raceId));
    },
    setSelectedCandidate: (candidateId) => {
      dispatch(setSelectedCandidate(candidateId));
    },
    createFlaggedTopic: (fields) => {
      dispatch(createFlaggedTopic(fields));
    },
    fetchAllTopicsForRace: (raceId) => {
      dispatch(fetchAllTopicsForRace(raceId));
    },
    setRaceTopicMeaning: (raceId, topic, meaning) => {
      dispatch(setRaceTopicMeaning(raceId, topic, meaning));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Candidate);
